import React, { useEffect, useRef, useState } from 'react';
import './style.css';
import { ConfigProvider, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import * as dashjs from 'dashjs';
import DashPlayer from './components/DashPlayer';

interface PlayerProps {
    source: any;
    type: 'mp4' | 'jpg' | 'm4a' | 'mpd';
    alt?: string;
    authToken: string;
    userLogin: string;
}

const Player: React.FC<PlayerProps> = ({
    source,
    type,
    alt = 'Media content',
    authToken,
    userLogin,
}) => {
    const [mediaUrl, setMediaUrl] = useState<string>('');
    const [error, setError] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const videoRef = useRef<HTMLVideoElement>(null);
    // const playerRef = useRef<any>(null);

    useEffect(() => {
        if (!source) {
            setError(true);
            setLoading(false);
            return;
        }

        const controller = new AbortController();
        const signal = controller.signal;

        const fetchMedia = async () => {
            try {
                setLoading(true);
                setError(false);
                const response = await fetch(source, {
                    headers: {
                        SmartDVRLogin: userLogin,
                        SmartDVRToken: authToken,
                    },
                });

                //@ts-ignore
                console.log('Response headers:', [...response.headers.entries()]);

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const blob = await response.blob();
                const url = URL.createObjectURL(blob);
                setMediaUrl(url);
            } catch (err) {
                console.error('Error fetching media:', err);
                setError(true);
            } finally {
                setLoading(false);
            }
        };

        fetchMedia();

        return () => {
            // controller.abort();
            if (mediaUrl) URL.revokeObjectURL(mediaUrl);
            // if (playerRef.current) {
            //     playerRef.current.destroy();
            //     playerRef.current = null;
            // }
        };
    }, [source, authToken, userLogin, type]);

    if (loading) {
        return (
            <div className="player-loading">
                <Spin
                    tip="Загрузка медиа..."
                    indicator={<LoadingOutlined className={'spin-icon'} spin />}
                />
            </div>
        );
    }

    if (error) {
        return (
            <div className="player-error">
                <div className="error-content">
                    <h3>Ошибка загрузки медиафайла</h3>
                    <p>Попробуйте обновить страницу или обратиться в поддержку</p>
                </div>
            </div>
        );
    }

    return (
        <div className="player" style={{ width: '100%', height: '100%' }}>
            {type === 'mp4' ? (
                <video className="player-video" controls src={mediaUrl} autoPlay>
                    Ваш браузер не поддерживает тег video.
                </video>
            ) : type === 'm4a' ? (
                <DashPlayer source={source} type={type} />
            ) : type === 'mpd' ? (
                <DashPlayer source={source} type={type} />
            ) : (
                // <video
                //     ref={videoRef}
                //     className="player-video"
                //     controls
                //     // autoPlay
                //     style={{ width: '100%', height: '100%' }}
                // />
                <img className="player-photo" src={mediaUrl} alt={alt} />
            )}
        </div>
    );
};

export default Player;
